


















import {Component, Vue} from "vue-property-decorator";
import {AuthGetterTypes} from "@/store/auth/types";
import {
  AuthPolicy,
  formatRetireDate,
  needsMailAddressSetup
} from "@/components/domains/account/passwordless/authPolicy";
import {loadAuthPolicy} from "@/components/domains/account/passwordless/passwordlessService";

/**
 * 「メールアドレスを設定してください」（ログイン中・メールアドレスのない人、メールでログインが使えるときだけ）。
 * 閉じても、ページを読み込み直すと（次のログインで）また出る。
 */
@Component
export default class MailAddressBanner extends Vue {
  name = "MailAddressBanner";

  policy: AuthPolicy | null = null;
  dismissed = false;

  mounted() {
    loadAuthPolicy().then((policy) => {
      this.policy = policy;
    });
  }

  get show(): boolean {
    if (!this.policy || this.dismissed) {
      return false;
    }
    if (this.$route.path.startsWith("/mypage/mail-address")) {
      return false;
    }
    const authenticated = this.$store.getters[AuthGetterTypes.getIsAuthenticated];
    const user = this.$store.getters[AuthGetterTypes.getCurrentUser];
    return !!authenticated && needsMailAddressSetup(this.policy, user);
  }

  get deadline(): string {
    return this.policy ? formatRetireDate(this.policy.noEmailPasswordLoginRetiresAt) : "";
  }
}
